module.exports = __webpack_public_path__ + "img/unified-app-launch.39a43474.svg";